/* eslint-disable */
import { useNavigate } from "react-router-dom";
import {
  Bell,
  Eye,
  Home,
  Megaphone,
  Phone,
  ScrollText,
} from "lucide-react";

const TYPE_ICON = {
  "phone_access.viewed": Eye,
  "phone_change.submitted": Phone,
  "phone_change.approved": Phone,
  "phone_change.rejected": Phone,
  "villa_membership.submitted": Home,
  "villa_membership.approved": Home,
  "villa_membership.rejected": Home,
  "document.added": ScrollText,
  "document.comment_added": ScrollText,
  "announcement.published": Megaphone,
};

function timeAgo(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const diffS = Math.max(1, Math.floor((Date.now() - then) / 1000));
  if (diffS < 60) return `${diffS}s ago`;
  const m = Math.floor(diffS / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} hr ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d} day${d > 1 ? "s" : ""} ago`;
  return new Date(iso).toLocaleDateString();
}

export default function NotificationPanel({ bell, onClose }) {
  const navigate = useNavigate();
  const items = bell.items;
  const hasUnread = bell.unreadCount > 0;

  const handleRowClick = async (n) => {
    if (!n.read_at) bell.markRead(n.id);
    if (n.link) navigate(n.link);
    onClose();
  };

  return (
    <div className="vsn-panel" role="dialog" aria-label="Notifications">
      <div className="vsn-panel-head">
        <h3>Notifications</h3>
        <button
          type="button"
          className="vsn-mark-all"
          disabled={!hasUnread}
          onClick={(e) => {
            e.stopPropagation();
            bell.markAllRead();
          }}
        >
          Mark all read
        </button>
      </div>

      {bell.loading && items.length === 0 && (
        <div className="vsn-empty">Loading…</div>
      )}
      {!bell.loading && items.length === 0 && (
        <div className="vsn-empty">
          <Bell size={26} strokeWidth={1.5} />
          <p>You're all caught up.</p>
        </div>
      )}

      {items.length > 0 && (
        <ul className="vsn-list">
          {items.map((n) => {
            const Icon = TYPE_ICON[n.type] || Bell;
            const unread = !n.read_at;
            return (
              <li
                key={n.id}
                className={`vsn-row ${unread ? "unread" : ""}`}
                onClick={() => handleRowClick(n)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") handleRowClick(n);
                }}
              >
                <span className="vsn-row-icon">
                  <Icon size={14} strokeWidth={2.1} />
                </span>
                <div className="vsn-row-body">
                  <div className="vsn-row-title">{n.title}</div>
                  {n.body && <div className="vsn-row-snippet">{n.body}</div>}
                  <div className="vsn-row-meta">{timeAgo(n.created_at)}</div>
                </div>
                {unread && <span className="vsn-row-dot" />}
              </li>
            );
          })}
        </ul>
      )}

      <div className="vsn-panel-foot">
        <button
          type="button"
          className="vsn-see-all"
          onClick={() => {
            navigate("/notifications");
            onClose();
          }}
        >
          See all notifications
        </button>
      </div>
    </div>
  );
}
